import MaskedInput from './MaskedInput';

// export types
export type { MaskedInputProps } from './MaskedInput';

// export components
export { MaskedInput };
export default MaskedInput;
